import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { UserGroupsField } from './UserGroupsField';

export const UserGroupsFieldExtension = FormFieldBlueprint.make({
  name: 'user-groups-field',
  params: {
    field: async () =>
      createFormField({
        name: 'UserGroupsField',
        component: UserGroupsField,
      }),
  },
});
